<template>
  <div>
    <iframe :src="docURL" :height="height" :width="width"> </iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: 800,
      width: 800
    };
  },
  computed: {
    docURL() {
      return `${this.$apiUrl}/docs`;
    }
  },
  methods: {
    handleWindowResize() {
      if (window.innerWidth > 1000) {
        this.width = (window.innerWidth / 2) * 1.5;
      } else {
        this.width = window.innerWidth / 2;
      }
    }
  },
  mounted() {
    this.handleWindowResize();
    window.addEventListener("resize", this.handleWindowResize);
  }
};
</script>
